import { Controller } from "@hotwired/stimulus"

// Pre-flight size check for PDF exports. Intercepts the export form's submit,
// asks the server whether the export will use the chunked pipeline (where the
// table of contents shows page numbers but isn't clickable), and if so shows
// a confirmation modal before starting the export.
//
// Attached to the export form; the modal markup lives inside the form with
// type="button" controls so it never submits on its own.
export default class extends Controller {
  static targets = ["modal", "recordCount"]
  static values = { url: String }

  async check(event) {
    if (this.confirmed) return

    event.preventDefault()

    let estimate = null
    try {
      // The form's embedded authenticity_token is per-form (scoped to the
      // create action), so the estimate endpoint needs the global token.
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
        body: new FormData(this.element),
      })
      if (response.ok) estimate = await response.json()
    } catch (_error) {
      // Fall through: never let the size check block an export.
    }

    if (estimate?.chunked) {
      this.showModal(estimate.record_count)
    } else {
      this.proceed()
    }
  }

  confirm() {
    this.hideModal()
    this.proceed()
  }

  cancel() {
    this.hideModal()
  }

  showModal(recordCount) {
    if (this.hasRecordCountTarget && recordCount) {
      this.recordCountTarget.textContent = Number(recordCount).toLocaleString()
    }
    this.modalTarget.style.display = ""
  }

  hideModal() {
    this.modalTarget.style.display = "none"
  }

  proceed() {
    this.confirmed = true
    this.element.requestSubmit()
    this.confirmed = false
  }
}
